import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { BaseRedirectLinkContainer } from "@circle-react/components/OnboardingComponents/BaseRedirectLinkContainer";

export const BackToOptionsLink = ({ url }) => (
  <div className="mb-6" id="back-link-container">
    <BaseRedirectLinkContainer>
      <Link to={url} id="back-link">
        {t("authentication_app.shared_links.back")}
      </Link>
    </BaseRedirectLinkContainer>
  </div>
);

BackToOptionsLink.propTypes = {
  url: PropTypes.string.isRequired,
};
